export default function defaultState() {
	return {
		drivers: [],
	};
}